export class QueuePattern {
    constructor(id: number) {
        this.pbxId = id;
    }

    id: number;
    number: string;
    name: string;
    type = 'QUEUE';
    strategy: string;
    timeout: number;
    retry: number;
    announceId: number;
    musicClassId: number;
    members: string;
    announceHoldTime: string;
    announcePosition: string;
    pbxId: number;
}
